import { Building2 } from "lucide-react";

function nodeCard(soc) {
  const holding = soc.type === "holding";
  const independante = !holding && !soc.parent_societe_id && !soc.type;
  return (
    <div className={`org-node ${holding ? "org-node-holding" : ""}`} data-testid={`org-node-${soc.societe_id}`}>
      <div className="flex items-center gap-2 justify-center">
        {soc.logo ? (
          <img src={soc.logo} alt="" className="w-6 h-6 rounded object-contain bg-white/5 flex-shrink-0" />
        ) : (
          <span className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0" style={{ background: soc.color || "#3b82f6" }}>
            <Building2 className="w-3 h-3 text-white" />
          </span>
        )}
        <span className="text-xs font-bold text-white whitespace-nowrap">{soc.name}</span>
      </div>
      <div className="mt-1.5 flex items-center justify-center gap-1.5">
        <span
          className={`text-[9px] font-bold px-2 py-0.5 rounded-full border ${
            holding
              ? "bg-[#f7c935]/15 text-[#f7c935] border-[#f7c935]/30"
              : independante
              ? "bg-white/5 text-slate-400 border-white/10"
              : "bg-sky-500/10 text-sky-300 border-sky-500/20"
          }`}
        >
          {holding ? "Holding" : independante ? "Indépendante" : "Filiale"}
        </span>
        {soc.forme_juridique && <span className="text-[9px] text-slate-500">{soc.forme_juridique}</span>}
      </div>
    </div>
  );
}

function buildBranch(soc, childrenMap, depth) {
  const kids = depth < 6 ? childrenMap[soc.societe_id] || [] : [];
  return (
    <li key={soc.societe_id}>
      {nodeCard(soc)}
      {kids.length > 0 && <ul>{kids.map((k) => buildBranch(k, childrenMap, depth + 1))}</ul>}
    </li>
  );
}

/** Organigramme du groupe — arbre de détention basé sur parent_societe_id. */
export default function GroupOrgChart({ societes = [] }) {
  if (!societes.length) return null;
  const ids = new Set(societes.map((s) => s.societe_id));
  const childrenMap = {};
  societes.forEach((s) => {
    const p = s.parent_societe_id && ids.has(s.parent_societe_id) ? s.parent_societe_id : "__root__";
    (childrenMap[p] = childrenMap[p] || []).push(s);
  });
  const roots = (childrenMap["__root__"] || []).slice().sort((a) => (a.type === "holding" ? -1 : 1));
  return (
    <div className="overflow-x-auto pb-2" data-testid="group-org-chart">
      <div className="org-tree min-w-max mx-auto px-4">
        <ul>{roots.map((r) => buildBranch(r, childrenMap, 0))}</ul>
      </div>
    </div>
  );
}
